<template>
  <div></div>
</template>

<script>
import config from '@/config';

export default {
  name: 'app-not-found',
  created() {
    window.location.href = config.CLIENT_APP_URL;
  },
};
</script>

<style></style>
